/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Vorfall`
};

const en_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incident`
};

const es_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incidente`
};

const fr_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incident`
};

const it_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incidente`
};

const nl_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incident`
};

const pt_traffic_event__car_incident = /** @type {(inputs: {}) => string} */ () => {
	return `Incidente`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.traffic_event__car_incident(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("traffic_event__car_incident", locale)
	if (locale === "de") return de_traffic_event__car_incident(inputs)
	if (locale === "en") return en_traffic_event__car_incident(inputs)
	if (locale === "es") return es_traffic_event__car_incident(inputs)
	if (locale === "fr") return fr_traffic_event__car_incident(inputs)
	if (locale === "it") return it_traffic_event__car_incident(inputs)
	if (locale === "nl") return nl_traffic_event__car_incident(inputs)
	return pt_traffic_event__car_incident(inputs)
};